import { TListAgencies, TListClients, TListCopy } from '../types';

export function isAgencyTypes(value: TListCopy): value is TListAgencies {
  return value.type === 'Organization';
}

export function isClientTypes(value: TListCopy): value is TListClients {
  return value.type === 'Agency';
}
